import { NavLink } from "react-router-dom";

interface Tab { to: string; icon: string; label: string; end?: boolean }

const TABS: Tab[] = [
  { to: "/",            icon: "📅", label: "Розклад", end: true },
  { to: "/me",          icon: "✓",  label: "Записи" },
  { to: "/me/kids",     icon: "👶", label: "Діти" },
  { to: "/me/history",  icon: "📜", label: "Історія" },
];

export function ParentTabBar() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 bg-tg-bg border-t border-tg-secondary/60 flex justify-around"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0)" }}
    >
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            `flex-1 py-2 flex flex-col items-center gap-0.5 text-[11px] transition ${
              isActive ? "text-tg-link" : "text-tg-hint"
            }`
          }
        >
          <span className="text-lg leading-none">{t.icon}</span>
          <span>{t.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
